import React from 'react';
import { OpsShellLayout, type OpsNavGroup } from '../ui/OpsShellLayout';

const GROUPS: OpsNavGroup[] = [
  {
    id: 'events',
    label: 'Events',
    items: [
      {
        name: 'Your events',
        href: '/organizer',
        description: 'Manage setup, roster, and day-of tools',
        isActive: (pathname) =>
          pathname === '/organizer' ||
          (/^\/organizer\/events\/\d+/.test(pathname) && !pathname.includes('/new')),
      },
      {
        name: 'Create event',
        href: '/organizer/events/new',
        exact: true,
        description: 'Publish a new show or meet',
      },
    ],
  },
  {
    id: 'money',
    label: 'Money',
    items: [
      {
        name: 'Payout setup',
        href: '/organizer/payments',
        description: 'Stripe Connect for paid entry & tickets',
      },
    ],
  },
  {
    id: 'help',
    label: 'Guides',
    items: [
      {
        name: 'Public events',
        href: '/events',
        description: 'See what attendees see',
      },
    ],
  },
];

/**
 * Organizer workspace shell with persistent sidebar navigation.
 */
const OrganizerLayout: React.FC = () => (
  <OpsShellLayout
    title="Organizer"
    roleLabel="Event organizer"
    navAriaLabel="Organizer"
    homeHref="/organizer"
    tip="Run registration, payouts, and gate day from one place."
    groups={GROUPS}
  />
);

export default OrganizerLayout;
